module.exports = __webpack_public_path__ + "assets/img/InvestmentAssistant.6a517389.png";